// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/global.js#1 $
'use strict';

/**
* @ngdoc service
* @name tcApp.GlobalService
* @description
* Global Service maintains state of the application,
* allowing different pieces of application to communicate with each other.
*
*/
angular.module('tc.global', [])
.service('GlobalService', function($rootScope, $templateCache, $location, $window, $animate,
									$document, $timeout, $route, $log, $mdMedia, $mdLiveAnnouncer, tcConstants,
									SystemRouter, BreadcrumbService, ElementStateService, PerformanceService) {
	
	var GlobalService = this;

	/**
	* @ngdoc property
	* @name globalContext
	* @propertyOf tcApp.GlobalService
	* @description
   	* Global Context defines current context of the whole system.
	* Those variables are used by Banner, Menus, Workflows.
	*
	*  - PatientID: Patient ID
	*  - EpisodeID: Episode ID
	*/
	this.globalContext = {};

	/**
	* @ngdoc property
	* @name configuration
	* @propertyOf tcApp.GlobalService
	* @description
   	* configuration includes any installation-specific configuration
	* These values are based on those stored in websys.Configuration
	*
	*  - date: configuration for date parsing
	*  - time: configuration for time parsing
	*  - currency: configuration for currency display and calculations
	*/
	this.configuration = {};
	this.logonData = {};
	this.serverMethods = [];
	/// an array of objects containing {PatientID, windowHandle, keepOpen} for opened window/tab
	this.linkedWindowItems = [];
	this.primaryComponent = {};

	var globalStrings = {};

	/**
	* @ngdoc method
	* @name clear
	* @methodOf tcApp.GlobalService
	* @description
   	* Clear Global Context
	*/
	this.clear = function() {
		this.globalContext = {
			PatientID: '',
			EpisodeID: '',
			showingButtonBar: false,
			showingTools: false,
		};
	};

	// Set up initial variables when creating the service
	this.clear();
	
	// Return true if positivelly  defined as HealthShare instance
	this.isHealthShareViewer=function() {
		if (angular.isUndefined(globalServiceInstance.configuration)) return false;		
		if (angular.isUndefined(globalServiceInstance.configuration.misc)) return false;
		if (angular.isUndefined(globalServiceInstance.configuration.misc.isHealthShare)) return false;
		// Now can return safely value according to a proper defined "isHealthShare" property
		return (globalServiceInstance.configuration.misc.isHealthShare);
	};
	
	// Return true if is a HealthShare viewer instance embedded
	this.isHealthShareViewerEmbedded=function() {
		if (!globalServiceInstance.isHealthShareViewer()) return false;
		// On cross-origin window "top" and "self" can read only , but cannot read deeper (i.e. not window.parent.xxx)
		if ($window.top!=$window.self) return true;
		return false;
	};
	
	/**
	* @ngdoc method
	* @name updateBannerData
	* @methodOf tcApp.GlobalService
	* @description
	* Update global context variables based on route parameters
   	* @param {object} routeParameters Parameters passed to the component
	*/
	this.updateBannerData = function(bannerData) {
		$rootScope.$broadcast('Global:updateBanner', bannerData);
		var currentPatientInContext = this.globalContext.PatientID;
		// Update globalContext variables
		if (angular.isDefined(bannerData.items)) {
			if (angular.isDefined(bannerData.items.BANNERPatientID)) {
				if (bannerData.items.BANNERPatientID.value != this.globalContext.PatientID) {
					this.NotifyPatientChangeEvent(true, bannerData);
				}
				this.globalContext.PatientID = bannerData.items.BANNERPatientID.value;
				this.globalContext.LBSubjectID = '';
			} else {
				if (angular.isDefined(this.globalContext.PatientID)) {
					this.NotifyPatientChangeEvent(false, undefined);
				} 
				if (angular.isDefined(bannerData.items.BANNERLBSubjectID)) {
					this.globalContext.LBSubjectID = bannerData.items.BANNERLBSubjectID.value;
					this.globalContext.PatientID = '';
				}
			}
			
			var EpisodeID = '';
			var LBEpisodeID = '';
			if (angular.isDefined(bannerData.items.BANNEREpisodeID)) {
				EpisodeID = bannerData.items.BANNEREpisodeID.value;
			} 
			if (angular.isDefined(bannerData.items.BANNERLBEpisodeID)) {
				LBEpisodeID = bannerData.items.BANNERLBEpisodeID.value;
			}
			this.globalContext.EpisodeID = EpisodeID;
			this.globalContext.LBEpisodeID = LBEpisodeID;

		} else {
			if (angular.isDefined(this.globalContext.PatientID) && (this.globalContext.PatientID != '')) {
				this.NotifyPatientChangeEvent(false, undefined);
			}
			this.globalContext.PatientID = '';
			this.globalContext.LBSubjectID = '';
			this.globalContext.EpisodeID = '';
			
			//reset the tcui embedded data
			var windowObject = (globalServiceInstance.isHealthShareViewerEmbedded()) ? $window : $window.top;
			windowObject.tcEmbeddedBanner = {
					EpisodeID: '',
					PatientID: '',
					otherParams: {},
			};
		}
		if (currentPatientInContext !== this.globalContext.PatientID) {
			globalServiceInstance.closeWindows();
		}
	};

	
	/**
	* @ngdoc method
	* @name NotifyPatientChangeEvent
	* @methodOf tcApp.GlobalService
	* @description
	* Notify to any external listeners on patient banner change
	* Only notify if is a HS instance and site have global flag tkHSCVNotifyPatientChangeEvent
	* that could be overridden in Region/System system.js
	* @param {boolean} havePatient True if have patient in context. 
   	* @param {object} bannerData Banner data fot patient. 
	*/
	this.NotifyPatientChangeEvent = function(havePatient, bannerData) {
		try {
			var HSPatientUpdateEventName = 'HS-patient-update';
			if (!$window.tkHSCVNotifyPatientChangeEvent) return;
			if (angular.isUndefined(globalServiceInstance.configuration)) return;
			var config = globalServiceInstance.configuration;
			if (angular.isUndefined(config.misc)) return;
			if (!((angular.isDefined(config.misc.isHealthShare) && (config.misc.isHealthShare)))) return;
			if (!havePatient) {
				$window.dispatchEvent(new CustomEvent(HSPatientUpdateEventName,{detail: {'InPatientContext': false,'PatientID': '', 'PatientURN':''}})); //eslint-disable-line
			} else {				
				var items = bannerData.items;
				var patientId = '';
				var patientURN='';
				if (angular.isObject(items.BANNERPatientID) && angular.isDefined(items.BANNERPatientID.value)) {
					patientId = bannerData.items.BANNERPatientID.value;
				}
				if (angular.isObject(items.BANNERRegistrationNo) && angular.isDefined(items.BANNERRegistrationNo.value)) {
					patientURN = bannerData.items.BANNERRegistrationNo.value;
				}
				$window.dispatchEvent(new CustomEvent(HSPatientUpdateEventName,{detail: {'InPatientContext': true,'PatientID': patientId,'PatientURN':patientURN}})); //eslint-disable-line
			}
		} catch (err) {
			$log.log('Notify patient change issue: ' + err);		
		}
	};
	
	this.getBanner = function(PatientID, EpisodeID, fromEmbedded, additionalParams, 
			LBSubjectID, LBEpisodeID, SubjectType) { 
		fromEmbedded = fromEmbedded || false;
		if ((!PatientID) && (!LBSubjectID)) {
			$rootScope.$broadcast('Global:updateBanner', {}, fromEmbedded);
			return;
		}
		
		var context = '';
		switch (SubjectType) {
			case 'V':
				context = 'SSubjectVet';
				break;
			case 'S':
				context = 'SSubjectEnv';
				break;
		}

		var params = {
			PatientID: PatientID,
			EpisodeID: EpisodeID,
			LBSubjectID: LBSubjectID,
			LBEpisodeID: LBEpisodeID,
			CONTEXT: context
		};
		if (fromEmbedded) angular.extend(params, additionalParams);
		
		var componentName = 'PAPerson.Banner';
		if (LBSubjectID) {
			componentName = 'LBSubject.Banner';
		}
		SystemRouter.fetchComponentData(componentName, params)
			.then(function(response) {
				$rootScope.$broadcast('Global:updateBanner', response.data, fromEmbedded);
				globalServiceInstance.closeWindows(fromEmbedded ? false : true);
			});
	};
	
	/// used to check if the page has a patient in context (patient banner is displayed)
	this.isPatientInContext = function() {
		// check curent context
		if (this.globalContext.PatientID !== '') return true;
		// check for the actual display, globalContext may be cleared if a nested component was reloaded
		return (angular.isObject($window.document.getElementById('tPAPerson_Banner')));
	};

	this.updateCounters = function(counters) {
		$rootScope.$broadcast('Global:updateCounters', counters);
	};

	this.callFunction = function(componentHtmlName, jsFunction, args, callbackFunction) {
		$rootScope.$broadcast('Global:callFunction', componentHtmlName, jsFunction, args, callbackFunction);
	};
	
	this.getComponentItem = function(id, componentName, callbackFunction) {
		$rootScope.$broadcast('Global:getItem', id, componentName, callbackFunction);
	};
	
	this.reloadComponent = function(componentHtmlName, requestVariables, callbackFunction) {
		$rootScope.$broadcast('Global:reloadComponent', componentHtmlName, requestVariables, callbackFunction);
	};
	
	this.updateChartName = function(chartName) {
		$rootScope.$broadcast('Global:updateChartName', chartName);
	};

	/**
	* @ngdoc method
	* @name updateButtonBar
	* @methodOf tcApp.GlobalService
	* @description
	* If a component reports as having buttons, set the global context variable that is checked by the footer.
	* Where a route has multiple components, any component with buttons will set the flag.
	* Footer resets the flag on route change
	*/
	this.updateButtonBar = function(componentHasButtons) {
		if (angular.isDefined(componentHasButtons)) {
			globalServiceInstance.globalContext.showingButtonBar = componentHasButtons;
		}
	};
	
	// Required for proper scrolling of body container 
	this.getButtonBarHeight = function() {
		if (this.globalContext.showingButtonBar) {
			var bodyElement = $window.document.getElementById('tc_Home-misc-body');
			var buttonBarElement = bodyElement.getElementsByClassName('buttonBar')[0];
			if (buttonBarElement) return buttonBarElement.offsetHeight;
		}
		return 0;	
	};

	// keep a reference to the service instance (inside function, this==undefined)
	var globalServiceInstance = this;
	
	// Retreive session data for menu and logon details
	this.setSessionData = function() {
		return SystemRouter.fetchSessionData()
			.then(function(sessionData) {
				globalServiceInstance.updateSessionData(sessionData);
			}, function(err) {
				$log.error(err);
			});
	};

	// Return true is using Right-to-Left language current direction at global scope
	this.isRTL = function() {
		return ($rootScope.langDirection == tcConstants.LANG_DIRECTION.RIGHT_TO_LEFT);
	};

	this.updateSessionData = function(sessionData) {
		if (sessionData.data.sessionLocked) return;
		globalStrings = sessionData.data.globalStrings;
		globalServiceInstance.logonData = sessionData.data.logonData;
		
		// Set direction according to the session user language
		// Added in root scope to use outside components in main app
		if (angular.isDefined(sessionData.data.logonData) && angular.isDefined(sessionData.data.logonData.langDirection)) {
			$rootScope.langDirection = sessionData.data.logonData.langDirection;	
		} else {
			$rootScope.langDirection = '';	
		}
		
		// We need Session Info on root scope to use it in HTTP interceptor
		$rootScope.sessionInfo = sessionData.data.logonData.sessionInfo;
		if (angular.isDefined(sessionData.data.logonData.isExternalAuth)) {
			$rootScope.isExternalAuth = sessionData.data.logonData.isExternalAuth;
			// This flag is required for the TCUI embedded mode when the logon session expires
			try {
				if ($rootScope.isExternalAuth) {
					$window.localStorage.setItem('tc.isExternalAuth', true);
				} else {
					$window.localStorage.removeItem('tc.isExternalAuth');
				}
			} catch (err) {
				$log.log('External Authentication flag storage issue: ' + err);
			}
		}
		globalServiceInstance.configuration = sessionData.data.configuration;
		if ((angular.isDefined(sessionData.data.configuration.misc.externalAuthLogoutURL))
			&& (sessionData.data.configuration.misc.externalAuthLogoutURL !== '')) {
			$rootScope.externalAuthLogoutURL = sessionData.data.configuration.misc.externalAuthLogoutURL;
		}
		globalServiceInstance.setWindowDateTimeConfig();
		globalServiceInstance.serverMethods = sessionData.data.serverMethods;
		
		if (globalServiceInstance.logonData.locId !== '') {
			try {
				// Set this token so we can discriminate between a legitimate logout and session timeout
				// Use session storage so it is cleared when browser is closed
				$window.sessionStorage.setItem('tc.loginSuccess', true);
				if ($location.path() !== '/Component/SSUserLogon') {
					$window.localStorage.setItem('tc.sessionActive', true);
				}
			} catch (err) {
				$log.log('Login token storage issue: ' + err);
			}
			
			// Initialise page load performance capturing once we have valid Login
			var capturePerformanceData = globalServiceInstance.logonData.capturePerformanceData; 
			PerformanceService.initialise(capturePerformanceData, globalServiceInstance.serverMethods[2]); 
		}
		// Intialise Breadcrumbs for embedded instance 
		if (globalServiceInstance.logonData.isClinicalViewer) {
			BreadcrumbService.initialiseEmbeddedInstance();
		} else {
			// For non-embedded instance, clear any leftover embedded activity flag
			try {
				$window.localStorage.removeItem('tc.embeddedActivity');
			} catch (err) {
				$log.log('Embedded flag storage issue: ' + err);
			}
		}
		
		$rootScope.$broadcast('Global:userLogon', sessionData.data);
	};

	// Sets date/time formats on window object
	this.setWindowDateTimeConfig = function() {
		if (angular.isDefined(this.configuration.date)) {
			$window['TK_dtsepartor'] = $window.dtseparator = this.configuration.date.separator;
			$window['TK_dtformat'] = $window.dtformat = this.configuration.date.format;
			$window['TK_tmseparator'] = $window.tmseparator = this.configuration.time.separator;
		}
	};

	this.getGlobalStrings = function() {
		return globalStrings;
	};
	
	this.getLogonData = function() {
		return globalServiceInstance.logonData;
	};
	
	var unloadHandler = function() {
		try {
			$window.localStorage.removeItem('tc.sessionActive');
		} catch (ex) {
			$log.log('Local storage issue:', ex);
		}
		if ((angular.isDefined(globalServiceInstance)) && (angular.isDefined(globalServiceInstance.serverMethods))) {
			var serverMethod = globalServiceInstance.serverMethods[0];
			if (angular.isDefined(serverMethod)) {
				globalServiceInstance.updateBannerData({});
				if (angular.isFunction($window.navigator.sendBeacon)) {
					// New function: Chrome, Edge, FF
					var parameters = [
						'WARGC=3',
						'WEVENT=' + serverMethod,
						'WARG_1=websys.SYSTEM',
						'WARG_2=',
						'WARG_3=TimeoutSession'
					];
					$window.navigator.sendBeacon('%25CSP.Broker.cls?' + parameters.join('&'));
				} else {
					// Old function: IE, Safari
					$window.cspHttpServerMethod(serverMethod, 'websys.SYSTEM', '', 'TimeoutSession');
				}
			}
		}
	};
	
	this.attachUnloadHandler = function() {
		// Don't attach unload handler if embedded into TC UI
		if ((!globalServiceInstance.isHealthShareViewerEmbedded()) && ($window.top.tkSystemUI == false)) return;
		$window.addEventListener('unload', unloadHandler);
	};
	
	this.detachUnloadHandler = function() {
		$window.removeEventListener('unload', unloadHandler);
	};
	
	try {
		if ($window.sessionStorage.getItem('tc.loginSuccess')) this.attachUnloadHandler();
	} catch (err) {
		$log.log('Login token storage issue: ' + err);
	}

	this.loginHandler = function() {
		this.clear();
		this.attachUnloadHandler();
		$rootScope.$broadcast('Global:sessionUnlocked');
		try {
			// Remove any breadcrumbs from a previous session
			// Do it on both logout and logon because logoutHandler will not be called on CSP session timeout
			BreadcrumbService.clearBreadcrumbData();
			ElementStateService.removeAllPersistant();
		} catch (err) {
			$log.warn('Login token storage issue: ' + err);
		}
		return this.setSessionData();
	};

	this.logoutHandler = function() {
		$templateCache.removeAll();
		this.detachUnloadHandler();
		$rootScope.$broadcast('Global:sessionLocked');
		try {
			$window.sessionStorage.removeItem('tc.breadcrumbs');
			$window.sessionStorage.removeItem('tc.loginSuccess');
			$window.sessionStorage.removeItem('tc.activity');
			$window.localStorage.removeItem('tc.sessionActive');
		} catch (err) {
			$log.warn('Login token storage issue: ' + err);
		}
	};

	this.triggerEvent = function(processEventOptions, $event) {
		// Extend this to include component name target for multi-component screens
		$rootScope.$broadcast('Global:triggerEvent', processEventOptions, $event);
	};

	this.toggleTools = function(value) {
		if (angular.isDefined(value)) {
			this.globalContext.showingTools = value;
		} else {
			this.globalContext.showingTools = !this.globalContext.showingTools;
		}
		$rootScope.$broadcast('Global:toggleTools', this.globalContext.showingTools);
	};
	
	this.setMenuTools = function(value) {
		$rootScope.$broadcast('Global:setMenuTools', value);
	};

	this.lockSession = function(manualLock) {
		// External Auth with configured externalAuthLogoutUrl will treat session lock as logout
		if ((GlobalService.logonData.isExternalAuth)
		&& (angular.isDefined(GlobalService.configuration.misc.externalAuthLogoutURL))
		&& (GlobalService.configuration.misc.externalAuthLogoutURL !== '')) {
			this.logout(manualLock);
		} else {
			this.isSessionLocked = true;
			$rootScope.$broadcast('Global:sessionLocked');
			if (manualLock) {
				$location.url('/Component/websys.LockSession');
			} else {
				$rootScope.$apply(function() {
					$location.url('/Component/websys.LockSession');
				});
			}
			return true;
		}
	};

	this.unlockSession = function() {
		// Timeout is required to fix IE11 crash
		// http://stackoverflow.com/questions/13853844/angular-js-ie-error-10-digest-iterations-reached-aborting
		$timeout(function() {
			$window.history.go(-2);
		}, 0);
		this.isSessionLocked = false;
		$rootScope.$broadcast('Global:sessionUnlocked');
		return true;
	};
	
	/**
	* @ngdoc method
	* @name runWhenStable
	* @methodOf tcApp.GlobalService
	* @description
	* Runs the passed function when the document is stable
	* Wrapper for angular.getTestability, with fallback to $timeout
	* @param {Function} functionToRun Function to run when the document is stable
	*/
	this.runWhenStable = function(functionToRun) {
		var testabilityService = null;
		try {
			testabilityService = angular.getTestability(angular.element($document[0].body));
		} catch (ex) {
			$log.error(ex);
			testabilityService = null;
		}
		if (testabilityService) {
			testabilityService.whenStable(functionToRun);
		} else {
			$timeout(functionToRun);
		}
	};

	/**
	* @ngdoc method
	* @name focusFirst
	* @methodOf tcApp.GlobalService
	* @description
	* Focus first element of the form on screen
	* 
	* @param {boolean} Focus Patient Banner Skip Nav link if element exists
	* @param {boolean} Force focus
	*/
	var userAgent = $window.navigator.userAgent || $window.navigator.vendor || $window.opera;
	var isIos = userAgent.match(/ipad|iphone|ipod/i);
	var isAndroid = userAgent.match(/android/i);
	var focusFirst = function(checkBannerSkipNav, forceFocus) {
		if (isIos || isAndroid) return;
		if ((angular.isDefined($route.current.params))
			&& (angular.isDefined($route.current.params.chartItem)) && (forceFocus !== true)) return;
		
		// Use this so we execute the focus after the DOM is rendered, for cross browser compatibility
		// http://stackoverflow.com/questions/11953348/angularjs-callback-after-render-work-with-dom-after-render/
		angular.getTestability(angular.element($document[0].body)).whenStable(function() {
			// Enable animation after routing
			$animate.enabled(true);

			// Don't re-focus if user already focused
			var overrideUserFocusElements = ['tc_NavBar-misc-homeButton','tc_Breadcrumbs-back', 'tc_NavBar-misc-menuButton'];
			if (($window.document.activeElement) && ($window.document.activeElement.tagName !== 'BODY')
			&& (overrideUserFocusElements.indexOf($window.document.activeElement.id) === -1)
			&& (forceFocus !== true)) {
				return;
			}
			
			if ((angular.isDefined(checkBannerSkipNav)) && (checkBannerSkipNav === true)) {
				// If Banner displayed, focus skipNav link if it exists
				if (globalServiceInstance.globalContext.PatientID !== '') {
					var bannerSkipNav = $window.document.getElementById('tc_Banner-misc-skipNav');
					if (bannerSkipNav) {
						bannerSkipNav.focus();
						return;
					}
				}	
			}
			
			// If we are scrolling to chart Item do not focus First
			if ((ElementStateService.get('chartScrollItem', angular.toJson($route.current.params)))
			&& (forceFocus !== true)) {
				return;
			}
			
			var forms = $document[0].forms || [];
			var foundElement = false;
			for (var i = 0; ((!foundElement) && (i < forms.length)); i++) {
				foundElement = focusFirstInElement(forms[i]);
			}
		});
	};
	this.focusFirst = focusFirst;
	
	/**
	* @ngdoc method
	* @name focusFirstInElement
	* @methodOf tcApp.GlobalService
	* @description
	* Focuses the first child element of a container element, returns true if a focusable element was found
	*
	* @param {!angular.JQLite|!Element} Container element in which to focus the first element
	* @returns {boolean} true if a focusable element was found
	*/
	var focusFirstInElement = function(element) {
		if (!element) return;
		if (angular.isUndefined(element.tagName)) element = element[0];
		if (!element) return;
		var focusableElementTypes = ['INPUT','TEXTAREA','A','MD-CHECKBOX',
									'MD-TAB-ITEM','TR','MD-ICON','SPAN','TD','MD-CHIPS-WRAP'];
		if (GlobalService.isTouchDevice()) {
			return false;
		}
		var childElements = element.getElementsByTagName('*');
		var isVisible,isEnabled;
		
		for (var j = 0; j < childElements.length; j++) {
			var childElement = childElements[j];
			// Only focus to valid element types
			if (focusableElementTypes.indexOf(childElement.tagName) === -1) continue;
			
			// Don't focus on the patient banner
			if (childElement.id.indexOf('PAPerson_Banner') !== -1) continue;
			
			// Don't focus on the next/previous page links, or the search input in the header
			if ((childElement.id.indexOf('-misc-nextPage') !== -1)
				|| (childElement.id.indexOf('-misc-prevPage') !== -1)
				|| (childElement.id.indexOf('-header-search-input') !== -1)) continue;
			
			// Don't focus to non-component items, but allow focus to first checkbox for lists in select mode
			if (((childElement.tagName === 'MD-CHECKBOX') || (childElement.tagName === 'MD-ICON'))
			&& (childElement.id.indexOf('-item-') === -1)
			&& (!((childElement.id.indexOf('-misc-select') !== -1) 
			&& (childElement.id.indexOf('-misc-selectAll') === -1)))) continue;
			
			// Only focus to first row, when not in select mode
			if ((childElement.tagName === 'TR')
			&& (childElement.id.indexOf('-row-0') === -1)
			&& (!childElement.classList.contains('componentListRowDefaultAction'))) continue;
			
			// Only focus to span when icon profile is the element
			if ((childElement.tagName === 'SPAN')
			&& (!childElement.classList.contains('iconProfileIcon'))) continue;
			
			// Focus on action button
			if ((childElement.tagName === 'TD')
			&& (!childElement.classList.contains('actions-cell'))) continue;
			
			// Don't focus to the component header
			var parentElement = childElement.parentElement;
			if ((parentElement)
			&& ((parentElement.classList.contains('componentHeaderTools'))
			|| (parentElement.classList.contains('componentHeaderBarItem'))
			|| (childElement.classList.contains('componentHeaderToolsItem'))
			|| ((parentElement.parentElement)
				&& (parentElement.parentElement.classList.contains('componentHeaderBarItem'))))) {
				continue;
			}
			
			// https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom
			isVisible = (childElement.offsetParent !== null);
			isEnabled = (!childElement.readOnly) && (!childElement.disabled);
			
			if (isVisible && isEnabled && (childElement.tabIndex >= 0)) {
				childElement.focus();
				if ((childElement.tagName === 'INPUT') || (childElement.tagName === 'TEXTAREA')) {
					childElement.select();
				}
				return true;
			}
		}
		
		return false;
	};
	this.focusFirstInElement = focusFirstInElement;
	
	this.isTouchDevice = function() {
		// Firefox on a notebook with touch screen has 'ontouchstart' defined
		// This case shouldn't be considered a touch device
		// Since FF is not supported on mobile devices, we can always consider FF to be a non-touch device
		if ($window.navigator.userAgent.indexOf('Firefox') !== -1) return false;
		return angular.isDefined($window.document.ontouchstart);
	};
	
	// Prevent additional scrolling when already scrolling
	var isScrolling = false;

	/**
	* @ngdoc method
	* @name scrollToElement
	* @methodOf tcApp.GlobalService
	* @description
	* Scroll to the target element provided, using some vaguely sensible defaults
	* @param {object} target - The element to scroll the page to
	* @param {string} [offset] - Offset to pass to 'scrollToElementAnimated'
	* @param {object | string} [scrollElementOrId] - Container element that will be scrolled, object or id
	*/
	this.scrollToElement = function(target, offset, scrollElementOrId) {
		if (isScrolling) return;
		offset = parseInt(offset, 10);
		if (isNaN(offset)) offset = 0;
		var scrollElement = scrollElementOrId;
		if (angular.isString(scrollElementOrId)) {
			scrollElement = $window.document.getElementById(scrollElementOrId);
			if (!scrollElement) {
				$log.warn('No element found to scroll: ', scrollElementOrId);
				return;
			}
		}
		scrollElement = (scrollElement || $window.document.getElementById('tc_Home-misc-body'));
		var body = angular.element(scrollElement);
		if (!target || !body) return;
		isScrolling = true;
		return body.scrollToElementAnimated(target, offset,
									tcConstants.ANIMATION.SCROLL_DURATION,
									tcConstants.ANIMATION.SCROLL_FUNCTION).then(function() {
			isScrolling = false;
		}, function() {
			isScrolling = false;
		});
	};
	
	/**
	* @ngdoc method
	* @name scrollTop
	* @methodOf tcApp.GlobalService
	* @description
	* Scroll to the target position on the y-axis within the scroll container
	* @param {string} top - Top position
	* @param {string | object} [scrollElementId] - Id or HTML element for the scroll container, defaults to scrollable container element.
	*/
	var scrollTop = function(top, scrollElement) {
		if (isScrolling) return;
		if (angular.isString(scrollElement)) {
			scrollElement = $window.document.getElementById(scrollElement);
		}
		if (!scrollElement) {
			scrollElement = GlobalService.getScrollableContainer()[0];
		}
		scrollElement = angular.element(scrollElement);
		isScrolling = true;
		scrollElement.scrollTop(top, tcConstants.ANIMATION.SCROLL_DURATION,
								tcConstants.ANIMATION.SCROLL_FUNCTION).then(function() {
			isScrolling = false;
		}, function() {
			isScrolling = false;
		});
	};
	this.scrollTop = scrollTop;

	/**
	* @ngdoc method
	* @name getScrollableContainer
	* @methodOf tcApp.GlobalService
	* @description
	* Get the main scroll container for current screen. We will preserve scroll position for it.
	* @returns {object} The scrollable container as a jQueryLite-wrapped element
	*/
	this.getScrollableContainer = function() {
		var overlayElement = $window.document.getElementsByClassName('md-panel tcOverlay')[0];
		if (overlayElement) return angular.element(overlayElement);
		
		// On 'xs' size, the scrollable area is 'tc_Home-misc-body'
		if (!$mdMedia('xs')) {
			var uprWorkAreaContainerSelector = '.clsepr_UPR_Composite > .componentBody'
																		+ ' > .componentSection > .flex.componentBlock > .componentRow'
				+ ' > .flex.componentBlock:nth-child(3) > .componentRow:nth-child(2)';
			var uprWorkAreaContainer = $window.document.querySelector(uprWorkAreaContainerSelector);
			if (uprWorkAreaContainer) return angular.element(uprWorkAreaContainer);
			
			var chartContainer = $window.document.getElementById('tc_Chart-content');
			if (chartContainer) return angular.element(chartContainer);
			
			var pwbContainer = $window.document.getElementById('tc_PWB-tabContent');
			if (pwbContainer) return angular.element(pwbContainer);
			
			// ACN Search Tab
			var acnTabContainer = $window.document.getElementById('tc_ACN-ComponentTab');
			if (acnTabContainer) return angular.element(acnTabContainer);
			
			var worklistContainer = $window.document.getElementById('tc_Worklist-content');
			if (worklistContainer) return angular.element(worklistContainer);
		}
		return angular.element($window.document.getElementById('tc_Home-misc-body'));	
	};
	
	/**
	* @ngdoc method
	* @name getScrollableParent
	* @methodOf tcApp.GlobalService
	* @description
	* Given an HTMLElement node, returns its closest scrollable ancestor element
	* Defaults to the document body scroll container
	* @param {object} node - DOM node to start searching HTMLElement. jQuery wrapped elements will be unwrapped
	* @returns {object | null} Scrollable parent HTMLElement
	*/
	this.getScrollableParent = function(node) {
		if (angular.isUndefined(node)) return null;
		if (angular.isFunction(node.parent)) node = node[0];
		var isElement = (node instanceof HTMLElement); //eslint-disable-line
		var overflowY = (isElement && $window.getComputedStyle(node).overflowY);
		var isScrollable = ((overflowY !== 'visible') && (overflowY !== 'hidden'));

		if (!node) {
			return null;
		} else if (isScrollable && (node.scrollHeight >= node.clientHeight)) {
			return node;
		}

		return (this.getScrollableParent(node.parentNode)
				|| $window.document.getElementById('tc_Home-misc-body'));
	};
	
	/**
	* @ngdoc method
	* @name scrollElementIntoView
	* @methodOf tcApp.GlobalService
	* @description
	* Scrolls an element into view within its container
	* @param {object} toggleElement - Element that triggered the scroll
	* @param {object} contentElement - Element with the content that should be displayed in the view
	* @param {object} [containerElement] - Container element that will be scrolled. Defaults to scrollable container element.
	* @param {string | number} [offset] Offset in px to add to the scroll calculation
	*/
	this.scrollElementIntoView = function(toggleElement, contentElement, containerElement, offset) {
		if (isScrolling) return;
		if (!containerElement) {
			containerElement = GlobalService.getScrollableContainer()[0];
		}
		
		// Get the coordinates for all the elements
		var containerRect = containerElement.getBoundingClientRect();
		var toggleRect = toggleElement.getBoundingClientRect();
		var contentElementRect = contentElement.getBoundingClientRect();
		offset = parseInt(offset, 10);
		if (isNaN(offset)) offset = 0;
		
		// Only scroll if the content exceeds the container
		if (contentElementRect.bottom > (containerRect.bottom - offset)) {
			var scrollBy = (contentElementRect.bottom - containerRect.bottom);
			// Don't scroll past the toggle element
			if ((toggleRect.top - containerRect.top - scrollBy) < 0) {
				scrollBy = (toggleRect.top - containerRect.top);
			}
			scrollTop((containerElement.scrollTop + scrollBy + offset), containerElement);
		}
	};
	
	// Returns if an element or any of its parents are fixed position.
	// Where 'onlyVisible' is passed, only returns true if the parent elements are also visible
	var isFixed = function(elm, onlyVisible) {
		var el;
		if (angular.isObject(elm)) {
			el = elm[0] || elm;
		} else if (angular.isString(elm)) {
			el = $window.document.querySelector(elm);
		}
		while ((angular.isObject(el)) && (el.nodeName.toLowerCase() !== 'body')) {
			var elStyle = $window.getComputedStyle(el);
			if (elStyle.getPropertyValue('position').toLowerCase() === 'fixed') {
				if (onlyVisible && (elStyle.getPropertyValue('display') === 'none')) return false;
				return true;
			}
			el = el.parentElement;
		}
		return false;
	};
	
	/**
	* @ngdoc method
	* @name isElementVisible
	* @methodOf tcApp.GlobalService
	* @description
	* Returns the visibility of an element, taking into account ancestor element display style and fixed position
	* @param {object} element - Element to check for visibility
	* @returns {boolean} Whether the element is visible
	*/
	this.isElementVisible = function(element) {
		if (element.offsetParent !== null) return true;
		
		var elementStyle = $window.getComputedStyle(element);
		if (elementStyle.display === 'none') return false;
		if ((elementStyle.position === 'fixed') || (isFixed(element, true))) {
			return true;
		}
		return false;
	};
	
	/**
	* @ngdoc method
	* @name isElementInView
	* @methodOf tcApp.GlobalService
	* @description
	* Returns if an element is scrolled into view with respect to a container element
	* @param {object} element - Element to be checked
	* @param {object} [containerElement] - Optional container element, uses overlay or body element if not provided
	* @returns {boolean} Whether the element is scrolled into view with respect to a container element
	*/
	this.isElementInView = function(element, containerElement) {
		if (!element) return;
		var elementStyle = $window.getComputedStyle(element);
		if ((elementStyle.display !== 'none') && ((elementStyle.position === 'fixed') || (isFixed(element)))) return true;
		var buttonBarHeight = 0;
		if (!containerElement) {
			containerElement = GlobalService.getScrollableContainer()[0];
			buttonBarHeight = this.getButtonBarHeight();
		}
		// Only compare if the element is within the container
		if (!containerElement.contains(element)) return true;
		
		var elementRect = element.getBoundingClientRect();
		var containerRect = containerElement.getBoundingClientRect();
		return ((elementRect.top >= containerRect.top) && (elementRect.bottom <= (containerRect.bottom - buttonBarHeight)));
	};
	
	/**
	* @ngdoc method
	* @name logout
	* @methodOf tcApp.GlobalService
	* @description
	* redirects to the Logout route, allowing for simple logging out from within any controller
	*/
	this.logout = function(manualLogout) {
		this.updateBannerData({});
		if (manualLogout) {
			$location.url('/Logout');		
		} else {
			$rootScope.$apply(function() {
				$location.url('/Logout');
			});
		}
	};

	/**
	* @ngdoc method
	* @name urlToObject
	* @methodOf tcApp.GlobalService
	* @description
	* return URL parameters list a=b&c=d as a JavaScript object {a:b,c:d}
	*/
	this.urlToObject = function(url) {
		return SystemRouter.urlToObject(url);
	};
	
	/**
	* @ngdoc method
	* @name printViaServer
	* @methodOf tcApp.GlobalService
	* @description
	* Takes a set of parameters for printing and calls system.Printing method via processEvent
	* @param {object} requestParams parameters to be passed in the request 
	* @param {object} onPrintCallback function object to receive as a callback the URL with the document  
	*/
	this.printViaServer = function(requestParams, onPrintCallback) {
		if (!angular.isObject(requestParams)) requestParams = {};
		angular.extend(requestParams, {TPRINT: 1});
		
		SystemRouter.processEvent(requestParams)
		.then(function(responseData) {
			if (responseData.data.error) {
				$log.error(responseData.data.error);
			} else {
				$log.info('Print success!', responseData.data);
				try {
					if (angular.isDefined(onPrintCallback) && angular.isFunction(onPrintCallback)) {
						if (angular.isDefined(responseData.data) && angular.isDefined(responseData.data.ReprintViewDocURL)) {
							onPrintCallback(responseData.data.ReprintViewDocURL);
						}
					}
				} catch (err) {
					$log.warn('Error calling onPrintCallback callback on printViaServer: ' + err);	
				}
			}
		}, function(error) {
			$log.error(error);
		});
	};
	
	// Counts Angular $$watchers for the specified element and all children
	// By default, uses the main application element
	this.countWatchers = function(elementId) {
		var element;
		if (!elementId) {
			element = angular.element($window.document.querySelector('[ng-app]'));
		} else {
			element = angular.element($window.document.getElementById(elementId));
		}
		if (!element) {
			$log.warn('No element found: ', elementId);
			return;
		}
		
		var watchers = [];
		var countWatchersInternal = function(element) {
			angular.forEach(['$scope', '$isolateScope'], function(scopeProperty) {
				if (element.data() && Object.prototype.hasOwnProperty.call(element.data(), scopeProperty)) {
					angular.forEach(element.data()[scopeProperty].$$watchers, function(watcher) { //eslint-disable-line
						watchers.push(watcher);
					});
				}
			});

			angular.forEach(element.children(), function(childElement) {
				countWatchersInternal(angular.element(childElement));
			});
		};

		countWatchersInternal(element);

		// Remove duplicate watchers
		var watchersWithoutDuplicates = [];
		angular.forEach(watchers, function(item) {
			if (watchersWithoutDuplicates.indexOf(item) < 0) {
				watchersWithoutDuplicates.push(item);
			}
		});

		return watchersWithoutDuplicates.length;
	};
	
	/**
	* @ngdoc method
	* @name removeCachedLayoutTemplate
	* @methodOf tcApp.GlobalService
	* @description
	* Removes all cached layout templates for a component
	* Used by layout editor/picker when modifying layouts
	* @param {string} componentName [Optional] Name of the component for which to remove the cached layout templates
	*								If none is provided, all cached layout templates will be removed.
	*/
	this.removeCachedLayoutTemplate = function(componentName) {
		var removeAll = (angular.isUndefined(componentName) || (componentName === null) || (componentName === ''));
		// Copy the keys as the array can be modified by $templateCache.remove
		var cacheKeys = angular.copy($templateCache.getKeys());
		cacheKeys.forEach(function(cacheKey) { // eslint-disable-line angular/foreach
			if (removeAll) {
				// If no valid component name is provided, remove all layout templates (but not everything from $templateCache)
				if (cacheKey.indexOf('system.Router.cls?TLAYOUT=1') === 0) {
					$templateCache.remove(cacheKey);
				}
				return;
			}
			// Find all the templates for a component layout with any extra parameters (TUID, etc)
			var componentCacheKey = ('system.Router.cls?TLAYOUT=1&TCOMPONENT=' + componentName);
			if ((cacheKey === componentCacheKey)
				|| (cacheKey.indexOf(componentCacheKey + '&') === 0)) {
				$templateCache.remove(cacheKey);
				return;
			}
			if ((componentName === 'epr.floorplan') &&
				(cacheKey.indexOf('system.Router.cls?TLAYOUT=1&TFLOORPLAN=1') === 0)) {
				$templateCache.remove(cacheKey);
			}
			if ((componentName.indexOf('epr.Chart') === 0) &&
				(cacheKey.indexOf('system.Router.cls?TLAYOUT=1&TCHART=') === 0)) {
				$templateCache.remove(cacheKey);
			}
			if ((componentName === 'websys.LookUp.List') &&
				(cacheKey.indexOf('system.Router.cls?TLAYOUT=1&TLOOKUP=') === 0)) {
				$templateCache.remove(cacheKey);
			}			
		});
		
		return true;
	};
	
	// Returns the main CSP class name of the application (system.Home*.cls)
	this.getAppClassName = function() {
		var pathNameArray = $window.location.pathname.split('/');
		var appClassName = pathNameArray[pathNameArray.length - 1];
		if (angular.isDefined(appClassName) && (appClassName !== '')) {
			return appClassName;
		}
		return 'system.Home.cls';
	};
	
	/**
	* @ngdoc method
	* @name maskUrl
	* @methodOf tcApp.GlobalService
	* @description
	* Masks a url with TUIDs. Called from 'tkurlset' function but defined here so other controllers can use it
	* @param {string} url URL to mask
	* @param {string} replaceParams Parameters to replace where 'url' is an existing masked URL
	* @returns {string} Masked URL
	*/
	this.maskUrl = function(url, replaceParams) {
		if (url.indexOf('http') === 0) return url;
		if (!angular.isString(replaceParams)) replaceParams = '';
		
		url = $window.cspHttpServerMethod(GlobalService.serverMethods[1], url, 0, '', 1, replaceParams);
		// On session timeout, default back to the home workflow
		if (url === null) return '/Workflow';
		
		if (url.indexOf('#') !== 0) url = '#' + url;
		return url;
	};
	
	this.refreshNotifications = function(params) {
		if ((angular.isUndefined(params)) || (!Object.prototype.hasOwnProperty.call(params, 'PatientID'))) {
			params = {'PatientID': this.globalContext.PatientID};	
		}
		SystemRouter.fetchNotificationData(params)
		.then(function(responseData) {
			if (responseData.data.error) {
				$log.error(responseData.data.error);
			} else {
				$rootScope.$broadcast('Global:refreshNotifications', responseData.data.notifications);
			}
		}, function(error) {
			$log.error(error);
		});
	};

	// function to display toast notifications when the data is received outside of the normal counters cycle
	this.displayToasts = function(toasts) {
		if (!angular.isArray(toasts)) return;
		$rootScope.$broadcast('Global:displayToasts', toasts);
	};

	// function to provide supplemental alerts and statuses to screen reader users where
	// visual alert is not appropriate
	this.announce = function(message, politeness) {
		if (politeness === 'alert') {
			var alertElement = $window.document.getElementById('tc_Home-misc-alert');
			if (angular.isElement(alertElement)) {
				$timeout(function() {
					alertElement.textContent = message;
				}, 150);
			}	
		} else {
			$mdLiveAnnouncer.announce(message, politeness);
		}	
	};
	
	// Clears any announcements made to screen readers
	this.clearAnnouncements = function() {
		$mdLiveAnnouncer.announce('', 'off');
		var alertElement = $window.document.getElementById('tc_Home-misc-alert');
		if (angular.isElement(alertElement)) {
			alertElement.textContent = '';
		}			
	};
	
	// toggle aria-hidden property on main screen so Assistive Technology stays within modal when open
	this.onModalToggle = function(isOpen) {
		var mainScreen = $window.document.getElementById('tc_Home-misc-mainscreen');
		if (mainScreen) {
			if (isOpen) {
				mainScreen.setAttribute('aria-hidden', true);
			} else {
				mainScreen.setAttribute('aria-hidden', false);
			}
		}
	};
	
	/// close popup screens / tabs, opened from TrakCare
	this.closeWindows = function(fromRouteChange) {
		if (angular.isUndefined(fromRouteChange)) fromRouteChange = true;
		
		if ((angular.isDefined($window.frames['TRAK_main'])) 
		// cater for when pdf document/report is opened in TRAK_main
		&& (angular.isDefined($window.frames['TRAK_main']['websys_closeWindows']))) {
			if (fromRouteChange) $window.frames['TRAK_main']['websys_closeWindows']();
		}
		
		var currentPatientInContext = globalServiceInstance.globalContext.PatientID;
		angular.forEach(globalServiceInstance.linkedWindowItems, function(windowItem, index) {
			if (angular.isUndefined(windowItem) || (!angular.isObject(windowItem.windowHandle))
			|| (angular.isUndefined(windowItem.windowHandle.closed)) || (windowItem.windowHandle.closed)) {
				globalServiceInstance.linkedWindowItems.splice(index,1);
				return;
			}
			if (windowItem.keepOpen) return;
			
			// always close windows, when patient context is changed or cleared, or upon LockSession
			if ((globalServiceInstance.isSessionLocked) || (currentPatientInContext === '')
			|| ((windowItem.PatientID !== '') && (windowItem.PatientID !== currentPatientInContext))) {
				windowItem.windowHandle.close();
				globalServiceInstance.linkedWindowItems.splice(index,1);
			}
		});
	};
	
	/// open a popup window / new tab, and store the window handle to the popup
	this.openWindow = function(url, windowName, windowFeatures, keepWindowOpen) {
		if ((angular.isUndefined(windowName)) || (windowName === '')) {
			windowName = url.split('?')[0];
		}
		if (angular.isUndefined(windowFeatures)) windowFeatures = '';
		var openedWindowHandle = $window.open(url, windowName, windowFeatures);
		globalServiceInstance.linkedWindowItems.push({
			PatientID: globalServiceInstance.globalContext.PatientID,
			windowHandle: openedWindowHandle,
			keepOpen: keepWindowOpen
		});
	};
	
	/**
	* @ngdoc method
	* @name getLineHeight
	* @methodOf tcApp.GlobalService
	* @description
	* Returns the line height given the current screen size
	* @returns {string} Current line height
	*/
	this.getLineHeight = function() {
		return (tcConstants.DIMENSIONS.LINE_HEIGHT_REM *
				($mdMedia('max-width: 1920px') ? (tcConstants.DIMENSIONS.REM_BASE_SCALE_FACTOR * tcConstants.DIMENSIONS.REM_BASE)
				: tcConstants.DIMENSIONS.REM_BASE)
				);
	};
	
	/**
	* @ngdoc method
	* @name setPageTitle
	* @methodOf tcApp.GlobalService
	* @description
	* Sets the page title based on the system name and the current primary component
	* @param {object} primaryComponent Primary component object in the same format as setPrimaryComponent.
	*									When not passed, only system name will be used.
	*/
	this.setPageTitle = function(primaryComponent) {
		var pageTitle = '';
		if (angular.isObject(primaryComponent) && (primaryComponent.routePath !== '/websys.csp')) {
			if (angular.isString(primaryComponent.componentHeaderCaption)
				&& (primaryComponent.componentHeaderCaption !== '')) {
				pageTitle += primaryComponent.componentHeaderCaption;
			} else if (angular.isString(primaryComponent.componentName)
						&& (primaryComponent.componentName !== '')) {
				pageTitle += primaryComponent.componentName;
			}
		}
		if (angular.isString(globalServiceInstance.logonData.systemName)) {
			pageTitle += ((pageTitle !== '') ? ': ' : '') + globalServiceInstance.logonData.systemName;
		}
		// Page header is outside of the scope of AngularJS, use DOM directly
		$window.document.title = pageTitle;
	};
	
	/**
	* @ngdoc method
	* @name setPrimaryComponent
	* @methodOf tcApp.GlobalService
	* @description
	* Sets the primary component details for use in the page title and parameters passed to Help Viewer
	* @param {object} primaryComponent Primary component details, including properties:
	*									componentName, componentHeaderCaption, componentContext, routePath
	*/
	this.setPrimaryComponent = function(primaryComponent) {
		if (!angular.isObject(primaryComponent)) return;
		
		if (angular.isDefined(primaryComponent.componentName)) {
			// Only handle one component event per route. This is reset on route change success
			if (angular.isDefined(globalServiceInstance.primaryComponent.componentName)) return;

			angular.extend(globalServiceInstance.primaryComponent, primaryComponent);
		} else {
			globalServiceInstance.primaryComponent = primaryComponent;
		}
		globalServiceInstance.setPageTitle(primaryComponent);
	};
	
	/**
	* @ngdoc method
	* @name triggerWindowResize
	* @methodOf tcApp.GlobalService
	* @description
	* Dispatches a window resize event.
	* Used to trigger size recalculation manually for some elements (Tab Control, Dynamic Columns)
	*/
	this.triggerWindowResize = function() {
		var resizeEvent = $window.document.createEvent('HTMLEvents');
		if (!resizeEvent) return;
		resizeEvent.initEvent('resize', true, false);
		$window.dispatchEvent(resizeEvent);
	};
	
	// Returns the logout URL, including logic for external authentication
	// Attach to $rootScope so it can be used across config/services that would have circular dependencies on GlobalService
	$rootScope.getLogoutURL = function() {
		var logoutUrl;
		if (angular.isDefined($rootScope.isExternalAuth) && ($rootScope.isExternalAuth)) {
			if (angular.isDefined($rootScope.externalAuthLogoutURL)) {
				logoutUrl = $rootScope.externalAuthLogoutURL;
			} else {
				// External authentication is used but no URL configured: Return splash page for now, because tab cannot be closed
				logoutUrl = ($window.location.href.split('/csp/system.Home')[0] + '/default.htm');
			}
		} else {
			var pathNameArray = $window.location.pathname.split('/');
			var appClassName = pathNameArray[pathNameArray.length - 1];
			appClassName = ((angular.isDefined(appClassName) && (appClassName !== '')) ? appClassName : 'system.Home.cls');
			logoutUrl = appClassName;
			if ($window.location.hash.indexOf('/Direct/') != -1) {
				// Pass through any query parameters set on the main URL
				var urlParams = $location.absUrl().split('?')[1];
				if ((angular.isDefined(urlParams)) && (urlParams !== '')) {
					urlParams = urlParams.split('#')[0];
					if ((angular.isDefined(urlParams)) && (urlParams !== '')) {
						// For TrakCare internal development to pass these specific parameters for username & password to the IRIS login
						urlParams = urlParams.replace('TCDEVUserName=', 'IRISUsername=');
						urlParams = urlParams.replace('TCDEVPassword=', 'IRISPassword=');
						logoutUrl += ('?' + urlParams);
					}
				}
				logoutUrl += ('#/Component/SSUserLogon?Redirect=' + encodeURIComponent($window.location.hash));
			}
		}
		return logoutUrl;
	};

	// When changing routes, save the scroll position
	$rootScope.$on('$routeChangeStart', function onRouteChangeHandleScrolling($event, newRoute, oldRoute) { //eslint-disable-line angular/on-watch
		// Disable animation during routing
		$animate.enabled(false);
		var scrollElement = GlobalService.getScrollableContainer()[0];
		if ((scrollElement) && (angular.isDefined(oldRoute))) {
			if (scrollElement.scrollTop > 0) {
				ElementStateService.set('scrollTop', scrollElement.scrollTop, angular.toJson(oldRoute.params));
			} else {
				// If the page is not scrolled, remove any existing scroll position
				ElementStateService.removeKey('scrollTop', angular.toJson(oldRoute.params));
			}
		}
	});

	// When we successfully change routes, toggle tools off and either scroll to previous position or focus first
	$rootScope.$on('$routeChangeSuccess', function onRouteChangeSuccess($event, newRoute) { //eslint-disable-line angular/on-watch
		GlobalService.toggleTools(false);
		GlobalService.updateButtonBar(false);
		GlobalService.clearAnnouncements();
		GlobalService.closeWindows();
		var locationPath = $location.path();
		// Reset the primary component details, so the first initialized component can repopulate it
		GlobalService.setPrimaryComponent({
			routePath: locationPath
		});
		
		var scrollTop = ElementStateService.get('scrollTop', angular.toJson(newRoute.params));
		if ((angular.isDefined(scrollTop)) && (scrollTop > 0)) {
			// If we are scrolling to the previous position, don't focus the first element
			$timeout(function scrollToPreviousPosition() {
				// Don't scroll if there are component messages
				if ($window.document.querySelector('.componentMessagesContainer') !== null) return;
				GlobalService.scrollTop(scrollTop);
			});
		} else if ((angular.isUndefined(newRoute.params.steps))
					&& (locationPath !== '/CloseReload')
					&& (locationPath !== '/Reload')) { // Don't fire an additional 'focus first' for navigation-only routes
			var mainScreenBody = $window.document.getElementById('tc_Home-misc-body');
			if (mainScreenBody) mainScreenBody.scrollTop = 0;
			
			if ((angular.isUndefined($route.current.params.TCOMPONENT))
				|| ($route.current.params.TCOMPONENT !== 'PAPerson.Banner')) {
				// focus first element, check for patient Banner skip nav link if extra Accessibility Support enabled for user
				var checkBannerSkipNav = globalServiceInstance.logonData.extraAccessibilitySupport;
				focusFirst(checkBannerSkipNav);	
			}
		}
	});
});
